import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface CancelButtonProps {
  onClick?: () => void;
  color: string;
  backgroundColor: string;
}

export function CancelButton(props: CancelButtonProps) {
  const { t } = useTranslation();
  const { onClick, color, backgroundColor } = props;

  return (
    <Button
      sx={{
        color,
        backgroundColor,
        height: "100%",
        width: "80%",
        fontSize: "20px",
        textTransform: "capitalize",
        pt: 1,
        "& .MuiButton-startIcon": {
          marginRight: 1
        }
      }}
      startIcon={<CancelPresentationIcon />}
      onClick={onClick ? (): void => onClick() : () => null}
    >
      {t("cancel")}
    </Button>
  );
}
